import { http } from '@/api/client/httpClient';
import type {
  DeployNoticeInput,
  DeployResultDto,
  DeploymentNoticeStatusDto,
  DeploymentNoticeStyleOption,
  DeploymentNoticeTemplateDto,
  DeploymentNoticeTemplateInput,
  TenantOptionDto,
} from '@/api/types/deploymentNotice';

// ABP conventional-controller mapping of
// Finkit.Host.DeploymentNotices.DeploymentNoticeAppService (no route attributes;
// Get* => GET with the Get prefix stripped from the route):
//   GetStatusAsync        -> GET    /api/app/deployment-notice/status
//   DeployAsync(input)    -> POST   /api/app/deployment-notice/deploy
//   ClearAsync(noticeId)  -> DELETE /api/app/deployment-notice/clear?noticeId=
//   GetStyleOptionsAsync  -> GET    /api/app/deployment-notice/style-options
//   GetTenantsAsync       -> GET    /api/app/deployment-notice/tenants
// and DeploymentNoticeTemplateAppService:
//   GetListAsync          -> GET    /api/app/deployment-notice-template
//   CreateAsync(input)    -> POST   /api/app/deployment-notice-template
//   UpdateAsync(id,input) -> PUT    /api/app/deployment-notice-template/{id}
//   DeleteAsync(id)       -> DELETE /api/app/deployment-notice-template/{id}
const BASE = '/api/app/deployment-notice';
const TEMPLATE_BASE = '/api/app/deployment-notice-template';

export const deploymentNoticeApi = {
  async getStatus(): Promise<DeploymentNoticeStatusDto> {
    const { data } = await http.get<DeploymentNoticeStatusDto>(`${BASE}/status`);
    return data;
  },

  async getStyleOptions(): Promise<DeploymentNoticeStyleOption[]> {
    const { data } = await http.get<DeploymentNoticeStyleOption[]>(`${BASE}/style-options`);
    return data;
  },

  async getTenants(): Promise<TenantOptionDto[]> {
    const { data } = await http.get<TenantOptionDto[]>(`${BASE}/tenants`);
    return data;
  },

  async deploy(input: DeployNoticeInput): Promise<DeployResultDto> {
    const { data } = await http.post<DeployResultDto>(`${BASE}/deploy`, input);
    return data;
  },

  async clear(noticeId: string): Promise<void> {
    await http.post(`${BASE}/clear/${noticeId}`);
  },

  async getTemplates(): Promise<DeploymentNoticeTemplateDto[]> {
    const { data } = await http.get<DeploymentNoticeTemplateDto[]>(TEMPLATE_BASE);
    return data;
  },

  async createTemplate(
    input: DeploymentNoticeTemplateInput,
  ): Promise<DeploymentNoticeTemplateDto> {
    const { data } = await http.post<DeploymentNoticeTemplateDto>(TEMPLATE_BASE, input);
    return data;
  },

  async updateTemplate(
    id: string,
    input: DeploymentNoticeTemplateInput,
  ): Promise<DeploymentNoticeTemplateDto> {
    const { data } = await http.put<DeploymentNoticeTemplateDto>(`${TEMPLATE_BASE}/${id}`, input);
    return data;
  },

  async deleteTemplate(id: string): Promise<void> {
    await http.delete(`${TEMPLATE_BASE}/${id}`);
  },
};
